import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['menu', 'trigger'];

  // action="click->float-menu#toggle"
  toggle() {
    this.adjustPosition();

    if (this.triggerTarget.classList.contains('is-active')) {
      this.hide();
    } else {
      this.#show();
    }
  }

  // action="resize@window->float-menu#hide"
  hide() {
    this.triggerTarget.classList.remove('is-active');
    this.menuTarget.style.display = 'none';
  }

  // action="scroll@window->float-menu#adjustPosition"
  adjustPosition() {
    const triggerPosition = this.triggerTarget.getBoundingClientRect();
    const positionY = triggerPosition.top;
    const positionX = triggerPosition.left;
    const triggerHeight = this.triggerTarget.clientHeight;
    this.menuTarget.style.top = `${positionY + triggerHeight + 8}px`;
    this.menuTarget.style.left = `${positionX}px`;
  }

  // action="click@document->float-menu#click"
  click({ target }) {
    if (
      target !== this.triggerTarget &&
      !this.triggerTarget.contains(target) &&
      target !== this.menuTarget &&
      !this.menuTarget.contains(target)
    ) {
      this.hide();
    }
  }

  #show() {
    this.triggerTarget.classList.add('is-active');
    this.menuTarget.style.display = 'block';
  }
}
